var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showApplicantInterest
        ? _c("JonInfo", {
            staticClass: "mb-3",
            scopedSlots: _vm._u(
              [
                {
                  key: "message",
                  fn: function() {
                    return [
                      _c("b", [_vm._v("Super!")]),
                      _vm._v(" Die Person hat ihr Interesse bereits bekundet.")
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2868168642
            )
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.forceTookPlace
        ? [
            _c("div", { staticClass: "font-weight-bold mb-2" }, [
              _vm._v("Ergebnis:")
            ]),
            _vm._v(" "),
            _c("RadioGroup", {
              attrs: { options: _vm.tookPlaceOptions, stacked: "" },
              model: {
                value: _vm.tookPlace,
                callback: function($$v) {
                  _vm.tookPlace = $$v
                },
                expression: "tookPlace"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.appointmentTookPlace
        ? _c("TookPlace", {
            staticClass: "mt-4",
            attrs: { message: _vm.message },
            on: {
              processed: function($event) {
                return _vm.$emit("processed")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.appointmentDidNotTakePlace
        ? _c("DidNotTakePlace", {
            staticClass: "mt-4",
            attrs: { message: _vm.message },
            on: {
              processed: function($event) {
                return _vm.$emit("processed")
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }